module.exports = __webpack_public_path__ + "img/productSatellite_19.4a6f43da.png";